import { create } from "zustand";
import { ActionsKey } from "../../../common/models/Actions";
import {
  initialReleaseOrderPageState,
  ReleaseOrderItemData,
} from "../core/_model.releaseOrder";
import {
  DefaultListResponse,
  DefaultListStateType,
} from "../../../common/models/StoreDefaultModel";

export type ActionedReleaseOrder = {
  data: ReleaseOrderItemData | null;
  action: ActionsKey;
};

type ReleaseOrderDataType = {
  releaseOrdersList: any;
  detail: ReleaseOrderItemData | null;
  actioned: ActionedReleaseOrder | null;
  totalItems?: number;
  setDetail: (detail: ReleaseOrderItemData | null) => void;
  setReleaseOrdersList: (list: DefaultListResponse | null) => void;
  setActioned: (act: ActionedReleaseOrder | null) => void;
};

export const useReleaseOrdersStore = create<ReleaseOrderDataType>(
  (set) => ({
    releaseOrdersList: [],
    detail: null,
    actioned: null,

    setDetail: (detail) => set((state) => ({ detail })),
    setReleaseOrdersList: (releaseOrdersData) =>
      set((state) => ({
        releaseOrdersList: releaseOrdersData?.member,
        totalItems: releaseOrdersData?.totalItems,
      })),
    setActioned: (act) => set((state) => ({ actioned: act } as any)),
  })
);

export const useReleaseOrdersListState = create<DefaultListStateType>(
  (set) => ({
    pageState: initialReleaseOrderPageState,
    setPageState: (pageState) => set((state) => ({ pageState })),
    resetPageState: () =>
      set(() => ({
        pageState: {
          page: 1,
          itemsPerPage: 10,
        },
      })),
  })
);
